
module.exports = {

    props:{
        paginator: {
            type : Object,
            required: true,
        }
    },

    data(){
        return {
            series: this.paginator.data,
        }
    }
}
